import {GeoLocation} from "../models/GeoLocation";
import {API_KEY} from "../AppSettings";

export function buildMapsUrl(location : GeoLocation, locale: string) : string{
    return `https://maps.googleapis.com/maps/api/staticmap?center=${location.latitude.toFixed(6)},${location.longitude.toFixed(6)}&zoom=15&size=640x640&markers=${location.latitude.toFixed(6)},${location.longitude.toFixed(6)}&language=${locale}&key=${API_KEY}`;
}